import type { ReactNode } from 'react';

/** Decorative layers only. The parent Home link owns the accessible name/action. */
export function MerchantBrand({ isArabic }: { readonly isArabic: boolean }): ReactNode {
  const src = isArabic
    ? '/mouja-arabic-pixel-media-logo.svg'
    : '/mouja-pixel-media-logo.svg';
  return (
    <span
      className={`mj-merchant-mark is-${isArabic ? 'ar' : 'en'}`}
      aria-hidden="true"
    >
      <img className="mj-merchant-mark-word" src={src} alt="" draggable={false} />
      <img className="mj-merchant-mark-core" src={src} alt="" draggable={false} />
      <img className="mj-merchant-mark-trail" src={src} alt="" draggable={false} />
      <span className="mj-merchant-mark-exhaust">
        {Array.from({ length: 6 }, (_, index) => (
          <i key={index} />
        ))}
      </span>
    </span>
  );
}
